module.exports = __webpack_public_path__ + "files/065dd66571f10386f7f49cba9d338dda.png";